/**
 * Frontend behavior for the property-reviews carousel: prev/next arrows page
 * two cards at a time (per the design), plus a "Show more" toggle that
 * expands every card in the block at once, since the reviews read as one set
 * rather than independently. Uses its own stepping logic rather than the
 * shared `_shared/carousel.ts` `initCarousel` (that steps one card at a time
 * and is also used by property-list - don't want to change its behavior).
 */
import $ from 'jquery';

const CARDS_PER_PAGE = 2;

document.addEventListener('DOMContentLoaded', () =>
	{
	$('.property-reviews').each((_i, block) =>
		{
		const $block = $(block);
		const $toggles = $block.find('.property-reviews__toggle');
		$toggles.on('click', () =>
			{
			$block.toggleClass('is-expanded');
			});

		const $track = $block.find('.property-reviews__track');
		const $cards = $track.find('.property-reviews__card');
		const $prev = $block.find('.property-reviews__arrow--prev');
		const $next = $block.find('.property-reviews__arrow--next');
		const track = $track.get(0) as HTMLElement;
		if (!track || !$cards.length)
			return;

		const currentIndex = () =>
			{
			let index = 0;
			$cards.each((i, card) =>
				{
				if ((card as HTMLElement).offsetLeft - track.offsetLeft <= track.scrollLeft + 1)
					index = i;
				});
			return index;
			};

		const scrollToIndex = (index: number) =>
			{
			const card = $cards.get(index) as HTMLElement | undefined;
			card?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
			};

		const updateArrowState = () =>
			{
			const maxScroll = track.scrollWidth - track.clientWidth;
			$prev.prop('disabled', track.scrollLeft <= 0);
			$next.prop('disabled', track.scrollLeft >= maxScroll - 1);
			};

		$prev.on('click', () =>
			{
			scrollToIndex(Math.max(0, currentIndex() - CARDS_PER_PAGE));
			});
		$next.on('click', () =>
			{
			scrollToIndex(Math.min($cards.length - 1, currentIndex() + CARDS_PER_PAGE));
			});

		$track.on('scroll', updateArrowState);
		updateArrowState();
		});
	});
